import React, { useState, useEffect } from 'react'
import { Option, Select, LinkedUserTag } from '../style'
import ApiService from '../../../services/ApiService'
import { companyComponentsProps, typesInterface } from '../types'

const SelectTypeComponent: React.FC<companyComponentsProps & { disabled?: boolean }> = (props) => {
  const { company, setCompany, disabled } = props
  const [types, setTypes] = useState<typesInterface[]>([])

  const handleSearchTypes = () => {
    ApiService.companies.getTypes()
      .then((response: any) => {
        if (response.data) setTypes(response.data)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  useEffect(() => {
    handleSearchTypes()
  }, [])

  const handleSelectType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const typeId = Number(e.target.value)
    if (!typeId) return

    const typeObject = types.find(t => t.id === typeId)
    if (!typeObject) return

    if (setCompany && company) {
      const currentTypes = Array.isArray(company.companyTypes) ? company.companyTypes : []
      if (currentTypes.some(t => t.id === typeId)) return

      setCompany((prev: any) => ({
        ...prev,
        companyTypes: [...currentTypes, typeObject]
      }))
    }
  }

  const handleRemoveType = (id: number) => {
    if (setCompany && company) {
      const currentTypes = Array.isArray(company.companyTypes) ? company.companyTypes : []
      setCompany((prev: any) => ({
        ...prev,
        companyTypes: currentTypes.filter(t => t.id !== id)
      }))
    }
  }

  const currentSelectedTypes = Array.isArray(company?.companyTypes) ? company.companyTypes : []
  const availableTypes = types.filter(t => !currentSelectedTypes.some(selected => selected.id === t.id))

  return (
    <div>
      <Select value="" onChange={handleSelectType} onFocus={handleSearchTypes} disabled={disabled}>
        <Option value="">Selecione</Option>
        {availableTypes.map((item, index) => (
          <Option key={index} value={item.id}>{String(item.typeName || '').trim()}</Option>
        ))}
      </Select>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
        {currentSelectedTypes.map((item) => (
          <LinkedUserTag key={item.id}>
            {String(item.typeName || '').trim()}
            {!disabled && (
              <button type="button" onClick={() => handleRemoveType(item.id)}>✕</button>
            )}
          </LinkedUserTag>
        ))}
      </div>
    </div>
  )
}

export default SelectTypeComponent